// extracted by mini-css-extract-plugin
export default {"cls1":"VeloCardForm-Content_cls1__hdMvB","cls2":"VeloCardForm-Content_cls2__6Q9Sv VeloCardForm-Content_cls1__hdMvB"};